import React from "react";
import Head4Top from "./Head4Top";
import Footer4Bottom2 from "./Footer4Bottom2";
import Css from './Layout.module.css'
import { useNavigate } from "react-router-dom";

export default function Layout4Login({ children, middle = undefined }) {
    const nav = useNavigate();

    const getMiddleClass = () => {
        if (middle === undefined) return '';
        return Css.Content_center;
    }

    const handleHomePage = () => {
        nav('/');
    }

    return (
        <>
            <div className={Css.Main_Content_Register2 + ' ' + getMiddleClass()}>
                {children}
            </div>
            <Footer4Bottom2 />
        </>
    );
}